(function () {
  // Event-Delegation an document statt direktem Handler am Button.
  // Grund: facets.js (Filtern/Sortieren) ersetzt beim Filtern den kompletten
  // #ProductGridContainer inkl. "Mehr laden"-Button. Ein direkt gebundener Handler
  // ginge dabei verloren → der Button wäre nach dem ersten Filtern tot.
  // Ein Handler an document überlebt das Neu-Rendern und findet den jeweils
  // aktuellen Button per closest().
  document.addEventListener('click', async function (e) {
    const button = e.target.closest('.collection-load-more');
    if (!button) return;

    const nextUrl = button.dataset.nextUrl;
    if (!nextUrl || button.disabled) return;

    button.disabled = true;
    const originalText = button.textContent;
    button.textContent = 'Lädt...';

    try {
      const response = await fetch(nextUrl);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newGrid = doc.querySelector('#product-grid');
      const currentGrid = document.querySelector('#product-grid');
      if (newGrid && currentGrid) {
        newGrid.querySelectorAll('.grid__item').forEach(function (item) {
          currentGrid.appendChild(item);
        });
      }


      /* ---- Die Adresse nennt die Seite, auf der man ist (28.09.2026) ----------
         VORBILD clearspring.co.uk, dort nachgemessen: Nach zwei Klicks auf
         "Load more" steht dort /collections/all?page=3 in der Adresszeile,
         history.length bleibt dabei bei 2 - also replaceState, kein neuer
         Verlaufseintrag.

         WARUM DAS DER ENTSCHEIDENDE PUNKT IST:
         Beim Zurueckkommen holt der Browser die Seite normalerweise aus seinem
         Vor-/Zurueck-Speicher (bfcache) - fertig gerendert, mit allen Kacheln und
         der Scrollposition. Gemessen am 28.09.2026: Live 16 ms, null Anfragen,
         Position auf den Pixel genau. Genau so machen es clearspring.co.uk,
         avocadostore.de und waschbaer.de, alle bei 12-16 ms.

         Greift der Speicher nicht - Seite neu geladen, neuer Tab, wenig Arbeits-
         speicher, oder auf dem Dev-Server, der ihn mit Cache-Control: no-store
         ausdruecklich verbietet -, liefert der Server die Seite neu. Und dann
         entscheidet die ADRESSE, was er liefert: Ohne page-Angabe die erste
         Portion (und unser Skript musste den Rest muehsam nachladen, sichtbar
         ruckelnd), mit page-Angabe genau die Seite, auf der man war.

         Der Preis ist derselbe wie bei Clearspring: Zurueck kommt man auf SEITE N,
         nicht auf die Sammlung aller bis dahin geladenen Kacheln. Dafuer passiert
         es in einem einzigen ruhigen Sprung statt als Aufbau vor den Augen.

         replaceState und nicht pushState: Sonst braeuchte jeder Klick auf
         "Mehr laden" einen eigenen Zurueck-Schritt, und man kaeme aus der Liste
         nicht mehr heraus.

         Filter und Sortierung bleiben erhalten, weil die Adresse aus
         paginate.next.url stammt und deren Parameter mitfuehrt. */
      /* ABGESCHALTET am 28.09.2026, einen Tag nach dem Einbau.

         Eingebaut war es als Nachbau von clearspring.co.uk: Dort schreibt "Load more"
         die geladene Seite per replaceState in die Adresse, und beim Zurueckkommen
         liefert der Server dann genau diese Seite.

         WARUM ES HIER NICHT PASST: Clearspring hat unter dem Knopf eine SICHTBARE
         Seitenleiste (1 2 3 ... 7). Dort ist eine Seitenzahl eine Groesse, die der
         Kunde kennt und anklicken kann. Unser Shop hat nur "Mehr laden" - eine
         durchgehende Liste ohne Seitenbegriff. In der Adresse stand dann eine Zahl,
         die im Laden nirgends vorkommt.

         Der Nutzer hat es am klarsten beschrieben: ?page=14 eingeben, es erscheint
         eine Liste, die oben anfaengt, und die naechste Charge heisst ?page=15 -
         waehrend man selbst "Seite 1 und Seite 2" sieht. Die Zahl zaehlt die Charge
         in der GESAMTSAMMLUNG, nicht die geladenen Chargen. Beides gleichzeitig kann
         eine Zahl nicht bedeuten.

         WAS BLEIBT: Der Gewinn kam ohnehin nicht von der Adresse, sondern davon, den
         Platz sofort zu reservieren und sofort zu springen, bevor irgendetwas geladen
         ist (siehe wiederherstellen in assets/zurueck-und-scrollposition.js). Das
         funktioniert ohne Seitenzahl genauso - die Zahl der geladenen Kacheln steht
         im Sitzungsspeicher.

         NICHT GELOESCHT, nur abgeschaltet: Sollte spaeter eine sichtbare Seitenwahl
         dazukommen, ist dies die Zeile, die dann wieder auf true gehoert.
         Bewusst ueber eine Konstante und nicht als Kommentarblock: Innerhalb stehen
         eigene Kommentarklammern, und die verschachteln sich in JavaScript nicht. */
      const ADRESSE_MIT_SEITE = false;
      if (ADRESSE_MIT_SEITE && window.history && history.replaceState) {
        try {
          history.replaceState(history.state, '', nextUrl);
        } catch (fehler) {
          /* Manche Browser verweigern replaceState bei zu vielen Aufrufen -
             dann bleibt die Adresse eben stehen, sonst aendert sich nichts. */
        }
      }

      const newButton = doc.querySelector('.collection-load-more');
      if (newButton && newButton.dataset.nextUrl) {
        button.dataset.nextUrl = newButton.dataset.nextUrl;
        button.disabled = false;
        button.textContent = originalText;
      } else {
        // Nur den Button ausblenden, NICHT den Wrapper: dessen Höhe hält den Abstand
        // zum Footer konstant (1,5 Rasterzellen), auch wenn alles geladen ist.
        button.style.display = 'none';
      }
    } catch (err) {
      console.error('Mehr laden failed:', err);
      button.disabled = false;
      button.textContent = originalText;
    }
  });
})();
